import { TimeAxisScaleType } from "./TimeAxisScaleType";
import { TimeAxisHighlightType } from "./TimeAxisHighlightType";

export const resolveTimeAxisHighlightType = (
  scaleType: TimeAxisScaleType
): TimeAxisHighlightType => {
  return  "line";
};
